import { Injectable } from '@angular/core';
import { ApiService } from '@taxilla-library/lib/services/api/api.service';

@Injectable({
    providedIn: 'root',
})
export class TaxillaApiService {
    constructor(private _api: ApiService) {}

    session = this._api.session;

    common = this._api.common;

    locations = this._api.locations;

    subscriptions = this._api.subscriptions;

    assets = this._api.assets;

    instances = this._api.instances;

    user = this._api.user;

    integrations = this._api.integrations;

    masters = this._api.masters;

    lookups = this._api.lookups;

    roles = this._api.roles;

    workflow = this._api.workflow;

    organization = this._api.organization;

    permissions = this._api.permissions;

    transformations = this._api.transformations;

    requests = this._api.requests;

    dashboard = this._api.dashboard;

    records = this._api.records;

    events = this._api.events;

    identityProviders = this._api.identityProviders;

    notifications = this._api.notifications;

    collaboration = this._api.collaboration;
}
